import { VariantWithImage } from '../types'

type CartQuantityAnalytics = {
    TRACK_CART_QUANTITY_DELTA: (
        variant: VariantWithImage,
        previousQuantity: number,
        newQuantity: number,
    ) => void
}

export const trackCartQuantityDeltaIfNeeded = (
    analytics: CartQuantityAnalytics,
    variant: VariantWithImage,
    previousQuantity: number,
    newQuantity: number,
    sellingPlanId?: string | null,
): void => {
    if (sellingPlanId === undefined && newQuantity !== previousQuantity) {
        analytics.TRACK_CART_QUANTITY_DELTA(
            variant,
            previousQuantity,
            newQuantity,
        )
    }
}
